import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerDepartmentService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerDepartmentDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { type TableParamsType } from '../../types/common';

const useGetDepartmentListWithPagination = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerDepartmentDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const departmentData = useQuery(
    ['getDepartmentListWithPagination', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CustomerDepartmentService.getApiCustomerApiAppCustomerDepartmentCustomerDepartmentList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return departmentData;
};

export default useGetDepartmentListWithPagination;
